import { defineStore } from 'pinia'

export const useVipStore = defineStore('vip', {
  state: () => ({
    vipList: [],
    showDefGroupId: 1,
  }),
  actions: {
    setVipList(list) {
      this.vipList = list
      if(list && list.length > 0){
        this.showDefGroupId = list[0].id;
      }
    },
    setShowDefGroupId(id) {
      this.showDefGroupId = id
    }
  }
})